const getters = {
  getDashboardConfig: state => state.dashboardConfig,
  getDashboardParams: state => state.dashboardParams,
  getCategory: state => state.category,
  getDashboardQuickSightConfig: state => state.quickSightDashboardConfig,
  getTransporters: state => state.transporterlist,
  isTransporterListLoading: state => state.isTransporterListLoading,
};

export default getters;
